import PubSub from "pubsub-js";

import { pubsubEvents } from "../../components/helpers/socket/pubsubEvent";
import optionsGridConfig from "../../platforms/cmed/OptionsGrid/optionsGridConfig";
import config from "../../components/helpers/socket/config";
import { MetricConstants } from "../../components/Constants";
import { endMetric } from "../metric-utils/metricUtils";
import { OrdersDataType } from "../../Constants";
/**
 * This is the main handler for received socket
 * messages that can be shared across your
 * widget content sandbox.
 *
 * The switch statement is intended to
 * match received actions to a dispatch event.
 */

export function cmed_trading_service_messageRecieved(data) {
  if (data.status && (data.status === "ERROR" || data.status === "FAILURE")) {
    switch (data?.errors[0]) {
      case pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT:
        console.log(`❌ ${data.errors[0]}`);
        PubSub.publish(
          pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
          {
            errors:
              "Your session has expired due to inactivity. Please log back in if you wish to access your account.",
          },
        );
        break;
      case pubsubEvents.errorMessage.CONNECTION_INTERRUPTION:
        console.log(`❌ ${data.errors[0]}`);
        PubSub.publish(
          pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
          { errors: pubsubEvents.errorMessage.CONNECTION_INTERRUPTION },
        );
        break;
      case pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN_SQUARE_BRACKETS:
        console.log(`❌ ${data.errors[0]}`);
        PubSub.publish(
          pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
          { errors: "CMED Token is unknown. Please try again." },
        );
        break;
      case pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN:
        console.log(`❌ ${data.errors[0]}`);
        PubSub.publish(
          pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
          { errors: "CMED Token is unknown. Please try again." },
        );
        break;
      case pubsubEvents.errorMessage.ERROR_MESSAGE_GENERIC:
        if (data?.action !== config.socket.actions.CMED_ORDER_AMEND) {
          console.log(`❌ ${data.errors[0]}`);
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            {
              errors: "There was an unexpected error while connecting to CMED.",
            },
          );
        } else {
          console.log(`❌ ${data.errors[0]}`);
          endMetric(MetricConstants.ORDER_MODIFY_LATENCY);
          PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
            errors: [
              data?.errors?.length > 0
                ? data?.errors[0]
                : data?.payload?.message,
            ],
          });
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_ORDER_AMENDMENT_ERROR,
            {
              errors: [
                data?.errors?.length > 0
                  ? data?.errors[0]
                  : data?.payload?.message,
              ],
            },
          );
        }
        break;
      default:
        break;
    }
    switch (data.type) {
      case config.socket.actions.CMED_LOGON:
        console.log(`❌ ${data.type}`);
        if (data?.errors[0] === pubsubEvents.errorMessage.MESSAGE_UNAUTH) {
          console.log(`❌ ${data.errors[0]}`);
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_MODAL_LOGOUT,
          );
        } else if (
          data?.errors[0] === pubsubEvents.errorMessage.CMED_SERVICE_UNAVAILABLE
        ) {
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            {
              errors: "Connection to server failed",
            },
          );
        } else if (
          data?.errors[0] ===
          pubsubEvents.errorMessage.UNAUTHORIZED_USER_MESSAGE
        ) {
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            {
              errors:
                "You do not have access to CME Direct Mobile. Please contact your firm administrator.",
            },
          );
        } else if (
          data?.errors[0] !==
          pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT
        ) {
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            {
              errors:
                "There was an issue while logging in. If this persists, please reach out to GCC. Reason : Login timed out with CMED.",
            },
          );
        }
        break;
      case config.socket.actions.CMED_CONNECTION:
        console.log(`❌ ${data.type}`);
        if (data?.errors[0]) {
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            data,
          );
        } else {
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            { errors: "There was an issue while connecting to CMED." },
          );
        }
        break;
      case config.socket.actions.CMED_LOGON_USER_SELECTED:
        console.log(`❌ ${data.type}`);
        if (
          data?.errors[0] ===
          pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT
        ) {
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            {
              errors:
                "Your session has expired due to inactivity. Please log back in if you wish to access your account.",
            },
          );
        } else {
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
            data,
          );
        }
        break;
      default:
        console.log(`🔴 No matching error action found for ${data.type}`);
        break;
    }
  } else {
    switch (data.type) {
      case config.socket.actions.CMED_LOGON:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_SUCCESS,
          data,
        );
        break;
      case config.socket.actions.CMED_LOGON_SUCCESS_RESPONSE:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_RESPONSE_SUCCESS,
          data,
        );
        break;
      case config.socket.actions.CMED_LOGON_SELECTION_NEEDED_RESPONSE:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_LOGIN_SELECTION_NEEDED,
          data,
        );
        break;
      case config.socket.actions.CMED_TRADING_ACCOUNTS:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_POST_LOGIN_USER_ACCOUNTS,
          data,
        );
        break;
      case OrdersDataType.TRADING_USER_DETAILS:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_ORDER_USER_DETAILS_UPDATE,
          data,
        );
        break;
      case config.socket.actions.CMED_CONNECTION:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_CONNECTION_SUCCESS,
          data,
        ); //no response from BE (not sure how to trigger it)
        break;
      // case 'OptionsGridGroup':
      //   console.log(`✅ ${data.type}`)
      //   dispatch(config.stompSubscriptionKeys.CMED_OPTIONSGRID_GROUP, data)
      //   break
      // case 'OptionsGridGroupItem':
      //   console.log(`✅ ${data.type}`)
      //   dispatch(config.stompSubscriptionKeys.CMED_OPTIONSGRID_GROUP_ITEM, data)
      //   break
      default:
        console.log(`🔴 No matching action found for ${data.type}`);
        break;
    }
  }
  console.groupEnd();
}

// export { cmed_trading_service_messageRecieved as default }
